export default "__VITE_ASSET__CNe6pKOo__"